export enum SpellCheckCommand {
  AddWord = 'addWord',
  CheckWord = 'checkWord',
}
